import React from "react";

const LinkedIn = ({className}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 41.8 41.8" className={className}><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><g id="Layer_1-3" data-name="Layer 1"><path d="M20.9,0A20.9,20.9,0,1,0,41.8,20.9,20.89,20.89,0,0,0,20.9,0ZM13.4,29.7l-.2-12.8,4-.1.2,12.8Zm1.8-14.6a2.3,2.3,0,1,1,2.3-2.3A2.47,2.47,0,0,1,15.2,15.1ZM28.3,29.4l-.1-6.2c0-1.5-.1-3.4-2.1-3.4s-2.4,1.7-2.3,3.3l.1,6.3-4,.1-.2-12.8,3.8-.1v1.7h.1a4.1,4.1,0,0,1,3.7-2.1c4-.1,4.8,2.6,4.9,6l.1,7Z"/></g></g></g></svg>
  )
}

export default LinkedIn;